<template lang="html">
    <v-dialog
    persistent
    v-model="value"
    max-width="400">
        <v-card>
            <v-card-title class="headline primary white--text">
                <slot name="header" :numFeatures="numFeatures">
                    {{ numFeatures }} features at these coordinates
                </slot>
            </v-card-title>

            <v-card-text>
                <v-list>
                    <template v-for="(feature, index) in features">
                        <v-list-tile
                        avatar
                        ripple
                        @click="select(feature)"
                        :key="feature.properties.id"
                        >
                        <v-list-tile-content>
                            <slot name="listItem" :feature="feature">
                                <v-list-tile-title v-text="feature.properties.name"></v-list-tile-title>
                            </slot>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < features.length" :key="index"></v-divider>
                </template>
            </v-list>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="accent darken-1" flat="flat" @click.native="hide">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        // array of overlapping map features
        // (geojson with properties)
        features: {
            type: Array,
            required: true,
        },
        // v-model
        value: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            show: true,
        };
    },
    computed: {
        numFeatures() {
            return this.features.length;
        },
    },
    methods: {
        /**
         * emit an event to select the given feature
         * @param  {Object} feature geojson feature
         */
        select(feature) {
            this.$emit('select', feature);
            this.hide();
        },
        /**
         * emit event to hide the component
         */
        hide() {
            this.$emit('input', false);
        },
    },
};
</script>

<style lang="scss">
.overlap-picker {
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/OverlapPicker.vue